<div header class="text-lg fw-600 w-100 uppercase flex-row space-between items-center"><span>Notes</span>
    @if (!readOnly() && canAddNote) {
        <a mat-button (click)="onAddNote(); $event.stopPropagation();"><span class="text-lg link-active-color mr-4">+ Note</span></a>
    }
</div>
<div class="divider outline-color mb-3"></div>
<div class="notes-container">
    @for (note of notes; track note.id; let i = $index) {
        <div class="note-item flex-row items-start mb-3 w-100">
            <div class="flex-col ml-3 flex-1">
            <div  class="flex-row space-between items-start text-md w-100">
                @if(note.edited){<span><b>{{note.edited | date:'shortDate'}}</b> | {{note.edited | date:'shortTime'}} | {{note.userFullName}}</span>}
                @else{NEW NOTE}
                <div>
                    @if (!readOnly() && editNoteId!=note.id && canEditNote(note)) {
                        <button class="primary-color small-icon-button" mat-icon-button (click)="onEditNote(note)" matTooltip="Edit note"><mat-icon class="mat-icon-sm">edit</mat-icon></button>
                    }
                    @if (editNoteId==note.id) {
                        <button class="red-color small-icon-button" mat-icon-button (click)="onCancelNote(note)" matTooltip="Cancel edit"><mat-icon class="mat-icon-sm">cancel</mat-icon></button>
                    }
                    @if ((editNoteId==note.id || isNewNote(note)) && canSaveNote) {
                        <button class="green-color small-icon-button" mat-icon-button (click)="onSaveNote(note)" matTooltip="Save note"><mat-icon class="mat-icon-sm">check</mat-icon></button>
                    }
                </div>
            </div>
            @if (editNoteId!=note.id) {
                <div class="text-lg">
                    <span>{{note.note}}</span>
                </div>
            }
            @if (editNoteId==note.id || isNewNote(note)) {
                <div [formGroup]="noteForm" class="mr-3">
                    <mat-form-field  appearance="outline" class="w-100">
                        <textarea  matInput formControlName="note" rows="5" required></textarea>
                        @if (noteForm.get('note')!.errors?.['required']) {
                            <mat-error>Text is required</mat-error>
                        }
                    </mat-form-field>
                </div>
            }
            </div>
        </div>
    }
</div>